<template>
  <div class="ValidatingOfferCardContainer">
    <HotOfferCard
      v-bind="$attrs"
      :tag-type="cptdOfferTag.type"
      :tag-label="cptdOfferTag.label"
      :interest-rate="
        offer.display_interest_rate_monthly || offer.interest_rate_monthly || 0
      "
      :installment-value="offer.installment_amount"
      :duration="offer.duration || offer.duration_max"
      custom-title-label="a negociar"
      :custom-leading-caption-label="`em até ${offer.duration || offer.duration_max || 0}x`"
      :amount="offer.amount"
      :partner="offer.partner"
      @action-forward-click="onClick"
      @brand-click="onClick"
      @offer-conditions-click="onClick"
    />
    <slot name="modal" />
  </div>
</template>
<script>
import { UIFeedbackTypes } from '@/helpers/offer-types'
import { OfferStatus, OfferSubStatus } from '@/data/common'
import HotOfferCard from '~/aasgard/components/cards/HotOfferCard.vue'
export default {
  name: 'ValidatingOfferCardContainer',
  components: {
    HotOfferCard,
  },
  props: {
    offer: { type: Object, required: true },
  },
  emits: ['display-partner-validating-steps'],
  data() {
    return {
      OfferSubStatusMessagesEnum: {
        WAITING_FOR_VALIDATION: 'Aguardando resposta da parceira',
      },
      OfferSubStatusUIFeedbackEnum: {
        WAITING_FOR_VALIDATION: 'WARNING-LIGHT',
      },
    }
  },
  computed: {
    cptdOfferTag() {
      switch (this.offer.status) {
        case OfferStatus.VALIDATING:
          return {
            label: this.OfferSubStatusMessagesEnum[this.offer.sub_status],
            type: UIFeedbackTypes[
              this.OfferSubStatusUIFeedbackEnum[this.offer.sub_status]
            ],
          }
        default:
          return null
      }
    },
    cptdButtonDisabled() {
      const { sub_status } = this.offer
      switch (sub_status) {
        case OfferSubStatus.WAITING_FOR_VALIDATION:
          return false
        default:
          return true
      }
    },
  },
  methods: {
    onClick() {
      this.$emit('display-partner-validating-steps')
    },
  },
}
</script>
